<app-header *ngIf="!embedded"></app-header>
<div class="center-content main-container" role="main" >
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="!embedded"></app-footer>